import { Vue as _Vue } from "vue-property-decorator";

export function EventHub(Vue: typeof _Vue): void {
  Vue.prototype.$eventHub = new _Vue();
}
